import type { VerificationProgressPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import StatusCountView from '@UI/Store/Documents/Views/StatusCountView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The single class for a verification progress, bounded to a version, a section or a document
 * summary alike — the server already narrows the counts to the right scope; this View only copies
 * them. `byStatus` always carries the five verification states, in a fixed order, zero counts
 * included.
 */
class VerificationProgressView {
	readonly total: number;
	readonly verified: number;
	readonly remaining: number;
	readonly invalid: number;
	readonly byStatus: readonly StatusCountView[];

	constructor(payload: VerificationProgressPayload) {
		this.total = payload.total;
		this.verified = payload.verified;
		this.remaining = payload.remaining;
		this.invalid = payload.invalid;
		this.byStatus = payload.byStatus.map((entry) => new StatusCountView(entry));

		Object.freeze(this);
	}
}

export default VerificationProgressView;
